import personalInfo from './personalInfo'

export * from './personalInfo'
export default personalInfo
